import { type UserType } from '@/types';

import {
  CompanyEditSchema,
  NormalEditSchema,
  StudentEditSchema,
  TeacherEditSchema,
} from '.';

// userType에 따른 스키마 선택
export const getSchemaByUserType = (userType: UserType) => {
  switch (userType) {
    case 'student':
      return StudentEditSchema;
    case 'teacher':
      return TeacherEditSchema;
    case 'normal':
      return NormalEditSchema;
    case 'company':
      return CompanyEditSchema;
    case 'unknown':
    default:
      return NormalEditSchema;
  }
};
